<!-- Header -->
<div class="popup" style="width: 600px;">
    <div mat-dialog-title style="margin:0px;">
        Report Options - How To
    </div>

    <mat-dialog-content>
        <div style="padding: 10px;">

            <p>
                Report Options are used to save/hide parameters you would like, and these will be pre-populated
                whenever
                you come into a report.
            </p>
            <p>
                User level parameters which have been marked to save will be updated with the latest value you have selected each time you run a
                report.
            </p>
            <p>
                If you select to hide a parameter, save will be checked as well, as this will be the actual value since
                it will not be visible unless you click "Show Hidden Parameters" on the report page.
            </p>
            <p>
                District level parameters can only be defined by administrators, and will override any user saved
                parameters.
            </p>
            <p style="font-weight: bold;">
                For district level parameters, you should select any values you would like to save/hide prior to coming
                to
                the report options page, as these are the values which will be saved.
            </p>

            <p style="font-weight: bold; font-style: italic;">
                To be safe you should click "Show Hidden Parameters" on the report page to see which values will be saved.
            </p>

        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button style="float:right;" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </mat-dialog-actions>

</div>